module.exports = __webpack_public_path__ + "static/media/moon.b962c727.svg";